import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { RootState } from "src/redux/store";
import { authTokenKeyName } from "src/utils/configs/authConfig";
import { IMAGE_BASE_URL } from "src/utils/constants";

export const fileExplorerSlice = createApi({
  reducerPath: "fileExplorerSlice",
  baseQuery: fetchBaseQuery({
    baseUrl: `${IMAGE_BASE_URL}`,
    prepareHeaders: (headers, { getState, endpoint }) => {
      const token =
        (getState() as RootState)?.auth?.accessToken ||
        localStorage.getItem(authTokenKeyName);
      if (token && endpoint !== "getAccessModules") {
        headers.set("x-access-token", token);
      }
      return headers;
    },
  }),
  // tagTypes: tagTypes,
  endpoints: (builder) => ({
    // ADD
    addFileUrl: builder.mutation({
      query: (body) => ({
        url: "/admin/add-file",
        method: "POST",
        body,
      }),
    }),
  }),
});

export const { useAddFileUrlMutation } = fileExplorerSlice;
